import React from 'react'
import Robot from './Robot';
import './Robo.css';

function ReloadingScreen() {
  return (
    <div
        className="relative w-full h-screen bg-cover bg-center bg-no-repeat max-w-"
        style={{ backgroundImage: "url('/loading.jpg')" }}
      >
    <div className="robo">
      <Robot />
    </div>
    </div>
  )
}

export default ReloadingScreen